import { render, staticRenderFns } from "./Debugger.vue?vue&type=template&id=5d5e406a&scoped=true"
import script from "./Debugger.vue?vue&type=script&lang=ts"
export * from "./Debugger.vue?vue&type=script&lang=ts"
import style0 from "./Debugger.vue?vue&type=style&index=0&id=5d5e406a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e406a",
  null
  
)

export default component.exports